/* Draft presentation only. Selling-plan IDs, prices and purchase controls stay native. */
(() => {
  const match = location.pathname.match(/\/products\/([^/]+)/);
  if (!match) return;
  const spanish = document.documentElement.lang.toLowerCase().startsWith('es');
  const frequencyLabel = (amount, unit) => {
    if (!spanish) return `Deliver every ${amount} ${unit}${Number(amount) === 1 ? '' : 's'}`;
    const units = {day: ['día', 'días'], week: ['semana', 'semanas'], month: ['mes', 'meses'], year: ['año', 'años']};
    return `Cada ${amount} ${units[unit][Number(amount) === 1 ? 0 : 1]}`;
  };
  const setText = (node, text) => { if (node && node.textContent !== text) node.textContent = text; };
  fetch(`/products/${encodeURIComponent(decodeURIComponent(match[1]))}.js`)
    .then(response => { if (!response.ok) throw new Error('Product unavailable'); return response.json(); })
    .then(product => {
      const plans = new Map();
      for (const group of product.selling_plan_groups || []) {
        for (const plan of group.selling_plans) {
          const frequency = plan.options.find(option => option.name === 'Order Frequency and Unit')?.value;
          const parts = frequency?.match(/^(\d+)-(day|week|month|year)$/);
          if (!parts || !plan.recurring_deliveries) continue;
          const adjustments = plan.price_adjustments || [];
          const discount = adjustments.length === 1 && adjustments[0].value_type === 'percentage' && adjustments[0].order_count == null ? adjustments[0].value : null;
          plans.set(String(plan.id), {label: frequencyLabel(parts[1], parts[2]), discount});
        }
      }
      if (!plans.size) return;
      function update() {
        if (spanish) {
          document.querySelectorAll('.rc_popup').forEach(popup => {
            const button = popup.querySelector('.rc_popup_label_wrapper');
            if (button) button.setAttribute('aria-label', 'Detalles de la suscripción');
            setText(popup.querySelector('.rc_popup__label'), 'Detalles de la suscripción');
            const explanation = popup.querySelector('.rc_popup__how_it_works');
            setText(explanation?.querySelector('strong'), 'Cómo funcionan las suscripciones');
            const description = [...(explanation?.childNodes || [])].find(node => node.nodeType === Node.TEXT_NODE && node.textContent.trim());
            setText(description, 'Los productos se entregan automáticamente con la frecuencia que elijas. Puedes modificar o cancelar tu suscripción cuando quieras.');
            setText(popup.querySelector('.rc_popup__learn_more'), 'Más información');
            setText(popup.querySelector('.powered-by'), 'Con tecnología de');
          });
        }
        document.querySelectorAll('.shopify_subscriptions_app_container .subscription_group').forEach(group => {
          const inputs = [...group.querySelectorAll('input[data-radio-type="selling_plan"]')];
          if (!inputs.length || inputs.some(input => !plans.has(input.dataset.sellingPlanId))) return;
          const discounts = inputs.map(input => plans.get(input.dataset.sellingPlanId).discount);
          const sharedDiscount = discounts[0] > 0 && discounts.every(value => value === discounts[0]);
          setText(group.querySelector('.group_name'), sharedDiscount ? (spanish ? `Suscríbete y ahorra ${discounts[0]} %` : `Subscribe & save ${discounts[0]}%`) : (spanish ? 'Suscríbete a entregas periódicas' : 'Subscribe for repeat deliveries'));
          for (const input of inputs) {
            const plan = plans.get(input.dataset.sellingPlanId);
            const label = plan.label + (!sharedDiscount && plan.discount > 0 ? (spanish ? ` · Ahorra ${plan.discount} %` : ` · Save ${plan.discount}%`) : '');
            setText(input.closest('label')?.querySelector('.title_and_price_wrapper > span'), label);
            const accessible = spanish ? `${label}${plan.discount > 0 ? `. Ahorra ${plan.discount} %` : ''}. Precio del producto ${input.dataset.variantPrice}` : `${label}${plan.discount > 0 ? `. Save ${plan.discount}%` : ''}. Product price ${input.dataset.variantPrice}`;
            if (input.getAttribute('aria-label') !== accessible) input.setAttribute('aria-label', accessible);
          }
          if (!group.querySelector('[data-rz-subscription-explanation]')) {
            const note = document.createElement('p');
            note.dataset.rzSubscriptionExplanation = '';
            note.textContent = spanish ? 'Elige cada cuánto quieres recibir tu próximo pedido.' : 'Choose how often you receive your next order.';
            note.style.cssText = 'margin:0 0 12px;font-size:14px;line-height:1.4;';
            group.querySelector('.group_list')?.before(note);
          }
        });
      }
      let queued = false;
      const observer = new MutationObserver(records => {
        if (queued || !records.some(record => record.type === 'childList')) return;
        queued = true;
        requestAnimationFrame(() => { queued = false; observer.disconnect(); update(); observe(); });
      });
      function observe() { observer.observe(document.body, {childList:true, subtree:true}); }
      update(); observe();
    }).catch(() => { /* Keep the app's original wording if product data is unavailable. */ });
})();
